export default __webpack_public_path__ + "assets/png/bc6ff6b209b993541724fcc0afa66470.png";